import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { useState as m } from "react";
import { m as x } from "./tss-DN0acMKN.mjs";
const f = x()(({ palette: l, borderRadiuses: s }, { border: o, shape: t, size: a }) => {
  let r, e;
  if (t === "circle")
    a === "small" ? (r = "16px", e = "16px") : a === "large" ? (r = "32px", e = "32px") : (r = "20px", e = "20px");
  else {
    const i = a === "small" ? { height: "12px", width: "16px" } : a === "large" ? { height: "24px", width: "32px" } : { height: "15px", width: "20px" };
    r = i.width, e = i.height;
  }
  const c = t === "circle" ? s[1e3] : s[100];
  return {
    flagImage: {
      border: o ? `1px solid ${l.gray[100]}` : "none",
      borderRadius: c,
      boxSizing: "content-box",
      display: "block",
      height: e,
      objectFit: t === "circle" ? "cover" : "contain",
      width: r
    }
  };
});
function b({ border: l = !1, countryCode: s, id: o, shape: t = "rectangle", size: a = "medium" }) {
  const { classes: r } = f({ border: l, shape: t, size: a }), [e, c] = m(!1), i = () => `https://staticfe.bamboohr.com/assets/images/flags/${s}.svg`, g = t === "circle" && !e ? `https://staticfe.bamboohr.com/assets/images/flags/${s}_1x1.svg` : i();
  return /* @__PURE__ */ n.jsx("div", { "data-fabric-component": "FlagIcon", id: o, children: /* @__PURE__ */ n.jsx(
    "img",
    {
      alt: `${s} flag`,
      className: r.flagImage,
      onError: () => {
        t === "circle" && !e && c(!0);
      },
      src: g
    }
  ) });
}
export {
  b as F
};
//# sourceMappingURL=flag-icon-CUevYM6l.mjs.map
